import { CLOUDINARY_IMAGE_URL } from 'src/utils/constants/ApiConstants';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { PageNameEnums, TRAY_TAGS } from 'src/utils/constants/utilConstants';
import { getWebPImageURLParams } from 'src/utils/ImageHelper/ImageURLGenerator';
import { SUPPORTED_IMAGE_TYPE } from 'src/utils/ImageHelper/SupportedImageTypes';

import { newKeysList } from './SEOMetaUtils';
import { transformToCamelCase } from './transformToCamelCase';

const schemaThumbnailImageUrl = (arr: any, item: any, pageName?: string) => {
  item = transformToCamelCase(item, newKeysList);
  const imageParams = getWebPImageURLParams();
  const thumbnailImage = [];
  let imageType = SUPPORTED_IMAGE_TYPE.JPG;

  if (
    pageName === PageNameEnums.CHANNEL_DETAILS_PAGE ||
    pageName === PageNameEnums.TV_CHANNEL_DETAILS
  ) {
    imageType = SUPPORTED_IMAGE_TYPE.PNG;
  }

  for (let i = 0; i < arr.length; i++) {
    let path = '';
    let imageLabel = arr[i][2];
    let width = arr[i][0];
    let height = arr[i][1];

    if (imageLabel === TAG_NAME.PORTRAIT) {
      path = TAG_NAME.COVER;
    } else if (imageLabel === 'list_clean') {
      path = 'listclean';
    } else {
      path = imageLabel;
    }
    if (
      typeof item === 'object' &&
      typeof item.image === 'object' &&
      !item.image[path] &&
      pageName === PageNameEnums.CHANNEL_DETAILS_PAGE
    ) {
      imageLabel = 'channel_square';
      width = 386;
      height = 386;
      path = 'list';
    }

    const url = `${CLOUDINARY_IMAGE_URL}w_${width},h_${height}${imageParams}${
      item && item.id
    }/${imageLabel}/${item && item.image && item.image[path]}${imageType}`;
    if (!url.includes('undefined') && item && item.image && item.image[path]) {
      thumbnailImage.push(url);
    }
  }

  return thumbnailImage;
};

export const thumbnailImgUrl = (pageName: string, data: any) => {
  let image: any = [];
  if (
    pageName === 'showEpisodePage' ||
    pageName === 'zee5originalEpisodePage' ||
    pageName === 'newsDetailPage' ||
    pageName === 'videoDetailPage' ||
    pageName === 'musicDetailPage' ||
    pageName === 'showSeasonPage' ||
    pageName === 'zee5originalsSeasonPage' ||
    pageName === 'showsAllPage' ||
    pageName === 'videoPage' ||
    pageName === 'channel' ||
    pageName === 'musicAllPage' ||
    pageName === 'channelDetail'
  ) {
    image = schemaThumbnailImageUrl([[1170, 658, 'list']], data);
  } else if (
    pageName === 'movieDetailPage' ||
    pageName === 'zee5originalsDetailPage' ||
    pageName === 'showDetailPage' ||
    pageName === 'viewAllPage' ||
    pageName === 'movieAllPage' ||
    pageName === 'zee5originalsAllPage'
  ) {
    image = schemaThumbnailImageUrl([[1170, 658, 'list']], data);
  } else if (
    pageName === 'channelDetailPage' ||
    pageName === 'tvchannelDetail'
  ) {
    image = schemaThumbnailImageUrl(
      [[1170, 658, 'list_clean']],
      data,
      pageName
    );
  }

  return image;
};

export const ogTwitterImage = (pageName: string, data: any) => {
  const imageParams = getWebPImageURLParams();
  let image = '';
  let imageType = SUPPORTED_IMAGE_TYPE.JPG;
  if (
    pageName === PageNameEnums.CHANNEL_DETAILS_PAGE ||
    pageName === PageNameEnums.TV_CHANNEL_DETAILS
  ) {
    imageType = SUPPORTED_IMAGE_TYPE.PNG;
  }
  if (
    pageName === PageNameEnums.CHANNEL_DETAILS_PAGE ||
    pageName === PageNameEnums.TV_CHANNEL_DETAILS
  ) {
    let imageLabel = 'list_clean';
    let width = 1170;
    let height = 658;
    let path = 'listclean';

    if (
      typeof data === 'object' &&
      typeof data.image === 'object' &&
      !data.image[path]
    ) {
      imageLabel = 'channel_square';
      width = 386;
      height = 386;
      path = 'list';
    }
    image = `${CLOUDINARY_IMAGE_URL}w_${width},h_${height}${imageParams}${
      data && data.id
    }/${imageLabel}/${data && data.image && data.image[path]}${imageType}`;
  } else {
    image = `${CLOUDINARY_IMAGE_URL}w_${1170},h_${658}${imageParams}${
      data && data.id
    }/list/${data && data.image && data.image.list}${imageType}`;
  }

  return image;
};

/*/ Uderscore to camel case conversion /*/
export const underscoreToCamelCase = (str: string): string => {
  return str.replace(/_([a-z])/g, (_match: string, letter: string) => {
    return letter.toUpperCase();
  });
};

/*/ To handle scenarios where multiple tags are involved, check for the first tag match /*/
export const getFirstMatchingTag = (tags: string[]) => {
  if (!Array.isArray(tags)) {
    return null;
  }
  const matchedTags = tags.filter((tag) => {
    // converts the tag to lowercase for comparison
    const modifiedTag = tag
      .split('_')
      .map((item) => item.toLowerCase())
      .join('_');
    return TRAY_TAGS.indexOf(modifiedTag) !== -1;
  });
  let matchingTag = matchedTags.length ? matchedTags[0] : 'news_title';
  if (matchedTags.length && matchedTags.indexOf('plex_widget') !== -1) {
    matchingTag = 'plex_widget';
  }
  matchingTag = underscoreToCamelCase(matchingTag?.toLowerCase());
  return matchingTag;
};
